import { withPlaceholder } from '../../../Placeholders';
import { TextFieldPlaceholder } from '../../../Placeholders/Templates';

import { DivisionDropdown } from '..';

export default withPlaceholder({ customPlaceholder: TextFieldPlaceholder })(DivisionDropdown);
